import React from 'react';
import { COMMUNITY_RESOURCE_ICONS, DEFAULT_RESOURCE_ICON } from '@/assets/admin/CommunityResourceIcons';

export const ResourceIcon = ({
  icon,
  size = 16,
  color,
}: {
  icon?: string;
  size?: number;
  color: string;
}) => {
  const IconComp = (icon && (COMMUNITY_RESOURCE_ICONS as any)[icon]) || DEFAULT_RESOURCE_ICON;
  return <IconComp width={size} height={size} color={color} />;
};


